const Glide = require('@glidejs/glide')
const axios = require('axios')
const { list } = require('postcss')
import Splide from '@splidejs/splide'
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll'

import Swiper, { Navigation, Autoplay } from 'swiper'

Swiper.use([Navigation, Autoplay])

function GlideAutoHeight(Glide, Components, Events) {
	const Component = {
		mount() {
			if (!Glide.settings.autoHeight) return
			Components.Html.track.style.transition = 'height 200ms ease-in-out'
			this.updateTrackHeight()
		},

		updateTrackHeight() {
			if (!Glide.settings.autoHeight) return

			const activeSlides = Components.Html.slides.filter((slide, index) => {
				return index >= Glide.index && index <= Glide.index - 1 + Glide.settings.perView
			})

			const newMaxHeight = activeSlides.reduce((maxHeight, slide) => {
				return Math.max(maxHeight, slide.offsetHeight)
			}, 0)

			const glideTrack = Components.Html.track
			if (newMaxHeight !== glideTrack.offsetHeight) glideTrack.style.height = `${newMaxHeight}px`
		},
	}

	Events.on('run', () => {
		Component.updateTrackHeight()
	})
	Events.on('update', () => {
		Component.updateTrackHeight()
	})
	Events.on('resize', () => {
		Component.updateTrackHeight()
	})

	return Component
}

// function createBlockLanguageHtml(category, articles) {
// 	let categoryHtml = `<h2 class="mb-2"><a class="font-semibold text-xl inline-block pl-2 border-l-4 border-red-600 uppercase text-black hover:text-red-600" href="/du-lich.html" title="TOURISM">${category.name}</a></h2>`

// 	let smallArticlesHtml = ''

// 	articles.forEach((article)=> {
// 			smallArticlesHtml += `<div class="flex mb-3 pb-3">
// 			<div class="w-28 mr-4 flex-shrink-0">
// 				<a class="block w-full aspect-[1.5]" href="/du-lich/bright-spots-in-the-global-tourism-picture-k5zylw64R.html" title="Bright spots in the global tourism picture
// ">
// 				<img class="thumbnail" src="${article.}" alt="Bright spots in the global tourism picture
// ">
// 				</a>
// 			</div>
// 			<div>
// 			<a href="/du-lich/bright-spots-in-the-global-tourism-picture-k5zylw64R.html" title="Bright spots in the global tourism picture
// " class="inline-block font-bold text-base">
// 					<h3>Bright spots in the global tourism picture
// </h3>
// 			</a>
// 			</div>
// 		</div>`
// 	})

// 	// 	return  `<div class="w-1/3 px-4">
// 	//
// 	// 		<div class="h-[350px] border-b-2 border-gray-100 mb-6">
// 	// 			<a href="/du-lich/community-based-tourism-promoted-in-ethnic-minority-inhabited-hamlet-3tCtH2RIg.html" class="block w-full aspect-[1.5] mb-4">
// 	// 				<img class="thumbnail" src="https://media.baosonla.org.vn/thumb/300-200/public/anhnv_en/2023-08-21-oi/chieng-di-4.jpg" alt="Community-based tourism promoted in ethnic minority-inhabited hamlet">
// 	// 			</a>
// 	// 				<a href="/du-lich/community-based-tourism-promoted-in-ethnic-minority-inhabited-hamlet-3tCtH2RIg.html" title="Community-based tourism promoted in ethnic minority-inhabited hamlet"><h3 class="inline-block font-bold text-base line-clamp-2">Community-based tourism promoted in ethnic minority-inhabited hamlet</h3></a>
// 	// 	</div>
// 	// 				<div class="flex mb-3 pb-3">
// 	// 				<div class="w-28 mr-4 flex-shrink-0">
// 	// 					<a class="block w-full aspect-[1.5]" href="/du-lich/bright-spots-in-the-global-tourism-picture-k5zylw64R.html" title="Bright spots in the global tourism picture
// 	// ">
// 	// 					<img class="thumbnail" src="https://media.baosonla.org.vn/thumb/300-200/public/anhnv_en/2023-08-13-oi/ai72lhc2gnkclld3mhovw6clmm-9224.jpg" alt="Bright spots in the global tourism picture
// 	// ">
// 	// 					</a>
// 	// 				</div>
// 	// 				<div>
// 	// 				<a href="/du-lich/bright-spots-in-the-global-tourism-picture-k5zylw64R.html" title="Bright spots in the global tourism picture
// 	// " class="inline-block font-bold text-base">
// 	// 						<h3>Bright spots in the global tourism picture
// 	// </h3>
// 	// 				</a>
// 	// 				</div>
// 	// 			</div>
// 	// 				<div class="flex mb-3 pb-3">
// 	// 				<div class="w-28 mr-4 flex-shrink-0">
// 	// 					<a class="block w-full aspect-[1.5]" href="/du-lich/efforts-made-to-lure-tourists-to-moc-chau-national-tourist-area-U3eL3Be4R.html" title="Efforts made to lure tourists to Moc Chau National Tourist Area">
// 	// 					<img class="thumbnail" src="https://media.baosonla.org.vn/thumb/300-200/public/anhnv_en/2023-08-11-oi/img_4745(1).jpg" alt="Efforts made to lure tourists to Moc Chau National Tourist Area">
// 	// 					</a>
// 	// 				</div>
// 	// 				<div>
// 	// 				<a href="/du-lich/efforts-made-to-lure-tourists-to-moc-chau-national-tourist-area-U3eL3Be4R.html" title="Efforts made to lure tourists to Moc Chau National Tourist Area" class="inline-block font-bold text-base">
// 	// 						<h3>Efforts made to lure tourists to Moc Chau National Tourist Area</h3>
// 	// 				</a>
// 	// 				</div>
// 	// 			</div>
// 	// 				<div class="flex mb-3 pb-3">
// 	// 				<div class="w-28 mr-4 flex-shrink-0">
// 	// 					<a class="block w-full aspect-[1.5]" href="/du-lich/developing-rural-tourism-model-in-muong-va-hamlet-eHNit16VR.html" title="Developing rural tourism model in Muong Va hamlet">
// 	// 					<img class="thumbnail" src="https://media.baosonla.org.vn/thumb/300-200/public/khanhhb_en/2023-08-10-oi/72.jpg" alt="Developing rural tourism model in Muong Va hamlet">
// 	// 					</a>
// 	// 				</div>
// 	// 				<div>
// 	// 				<a href="/du-lich/developing-rural-tourism-model-in-muong-va-hamlet-eHNit16VR.html" title="Developing rural tourism model in Muong Va hamlet" class="inline-block font-bold text-base">
// 	// 						<h3>Developing rural tourism model in Muong Va hamlet</h3>
// 	// 				</a>
// 	// 				</div>
// 	// 			</div>
// 	// </div>`
// }

window.addEventListener('DOMContentLoaded', function (e) {
	try {
		// fetch('https://en.baosonla.org.vn/api/articles/recent', {
		// 	method: 'GET',
		// })
		// 	.then((res) => {
		// 		if (res.status === 200) {
		// 			return res.status
		// 		}
		// 	})
		// 	.then((data) => {
		// 		if (data && data.code === 200) {
		// 		}
		// 	})
		// 	.catch((err) => {
		// 		console.log('homepage.fetchBlockLanguage', { message: err.message })
		// 	})

		new Glide.default('#glideHighlightArticles', {
			type: 'carousel',
			startAt: 0,
			perView: 1,
			autoplay: 5000,
			animationDuration: 1000,
			animationTimingFunc: 'ease-in-out',
			autoHeight: true,
		}).mount({
			GlideAutoHeight,
		})

		// new Glide.default('#glideMultimedia', {
		// 	type: 'carousel',
		// 	startAt: 0,
		// 	perView: 3,
		// 	gap: 192,
		// 	autoplay: 5000,
		// 	focusAt: 'center',
		// 	animationDuration: 150,
		// 	autoHeight: true,
		// 	breakpoints: {
		// 		1365: {
		// 			gap: 105,
		// 		},
		// 	},
		// }).mount()

		// let multi_swiper = new Swiper('.multi', {
		// 	autoplay: {
		// 		delay: 5000,
		// 	},
		// 	speed: 1000,
		// 	slidesPerView: 3,
		// 	spaceBetween: 160,
		// 	slidesPerGroup: 1,
		// 	loop: true,
		// 	autoHeight: true,
		// 	navigation: {
		// 		nextEl: '.swiper-button-next',
		// 		prevEl: '.swiper-button-prev',
		// 	},
		// })
		// let multi_elem = document.querySelector('.multi')
		// let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
		// Object.assign(multi_elem.style, {
		// 	height: `${swiper_next_elem.clientHeight * 1.75}px`,
		// })

		// multi_swiper.on('slideChangeTransitionEnd', function () {
		// 	let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
		// 	console.log(7, swiper_next_elem.clientHeight * 1.75)
		// 	Object.assign(multi_elem.style, {
		// 		height: `${swiper_next_elem.clientHeight * 1.75}px`,
		// 	})
		// })

		let special_swiper = new Swiper('.emagazine', {
			autoplay: {
				delay: 3000,
			},
			speed: 1000,
			slidesPerView: 1,
			slidesPerGroup: 1,
			loop: true,
			autoHeight: true,
			navigation: {
				nextEl: '.special .swiper-button-next',
				prevEl: '.special .swiper-button-prev',
			},
		})

		let isPlayVideo = false
		let live = document.querySelector('#video-live')
		if (!live) {
			let video_swiper = new Swiper('.video-swiper', {
				speed: 1000,
				slidesPerView: 1,
				slidesPerGroup: 1,
				loop: true,
				autoHeight: true,
				autoplay: {
					delay: 5000,
				},
				navigation: {
					nextEl: '.video-swiper .swiper-button-next',
					prevEl: '.video-swiper .swiper-button-prev',
				},
			})
			video_swiper.on('activeIndexChange', function (evt) {
				if (window.players.length > 0) {
					window.players.forEach(function (instance, index) {
						instance.on('play', function () {
							if (!isPlayVideo) {
								video_swiper.autoplay.stop()
								isPlayVideo = true
							}
							instance.volume = 1
							window.players.forEach(function (instance1, index1) {
								if (instance != instance1) {
									instance1.pause()
								}
							})
						})
					})
				}
			})
		}

		// window.addEventListener('resize', function () {
		// 	let swiper_next_elem = multi_elem.querySelector('.swiper-slide-next article')
		// 	Object.assign(multi_elem.style, {
		// 		height: `${swiper_next_elem.clientHeight * 1.75}px`,
		// 	})
		// })

		/* 	let boxLocation = document.querySelector('.box-location')
	let selectListLocation, listLocation, locationName, viewMore, linkListLocation
	if (boxLocation) {
		selectListLocation = boxLocation.querySelector('.select-list-location')
		listLocation = boxLocation.querySelector('.list-location')
		locationName = boxLocation.querySelector('.location-name')
		viewMore = boxLocation.querySelector('.view-more')

		if (listLocation) {
			linkListLocation = listLocation.querySelectorAll('a')
		}
	}
	let locationArticles = document.querySelector('.location-articles') */

		// selectListLocation.addEventListener('click', function (e) {
		// 	listLocation.classList.toggle('hidden')
		// })

		/* 	document.addEventListener('click', function (e) {
		if (selectListLocation.contains(e.target)) {
			listLocation.classList.toggle('hidden')
		} else {
			if (!listLocation.classList.contains('hidden')) {
				listLocation.classList.add('hidden')
			}
		}
	})
	let urlOfFirstElem = '/events/eb2wt7nVR.html'
	axios(urlOfFirstElem, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			fetch: 'location',
		},
	})
		.then((data) => {
			locationArticles.innerHTML = data.data
		})
		.catch((err) => {
			console.log(err)
		})

	linkListLocation.forEach((elem) => {
		elem.addEventListener('click', function (e) {
			e.preventDefault()
			locationName.textContent = elem.textContent
			viewMore.href = elem.href
			let url = elem.href
			axios(url, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					fetch: 'location',
				},
			})
				.then((data) => {
					locationArticles.innerHTML = data.data
				})
				.catch((err) => {
					console.log(err)
				})
		})
	}) */

		// we need to set this here for now.
		// var marquee_vert
		// var marquee_hort

		// // first, let's grab the element we're going to move around
		var marquee_vertical = document.querySelector('#marquee-vertical')
		if (marquee_vertical) {
			let splideVert = new Splide('#marquee-vertical', {
				type: 'loop',
				direction: 'ttb',
				height: '600px',
				fixedWidth: '300px',
				autoHeight: true,
				drag: 'free',
				autoScroll: {
					speed: 1,
				},
				arrows: false,
				pagination: false,
			})

			splideVert.mount({ AutoScroll })
		}

		// var marquee_vertical_children = marquee_vertical.querySelectorAll( '.cell')

		// // first, let's grab the element we're going to move around
		var marquee_horizontals = document.querySelectorAll('.splide.splide-hori')

		marquee_horizontals.forEach((marquee_horizontal) => {
			let id = marquee_horizontal.getAttribute('id')
			if (marquee_horizontal) {
				let splideHori = new Splide(`#${id}`, {
					type: 'loop',
					drag: 'free',
					focus: 'center',
					height: '9rem',
					perPage: 3,
					autoWidth: true,
					autoScroll: {
						speed: 1,
					},
					arrows: false,
					pagination: false,
				})

				splideHori.mount({ AutoScroll })
			}
		})

		// var marquee_horizontal_children = marquee_horizontal.querySelectorAll( '.cell')

		// // the key here is not to animate all of the cells in the grid, which might be products or what have you; we have a grid constrained by a container, so we can just translate the entire grid and only the part of the grid that fits into the container will be visible anyway
		// function createMarquee(marquee, parent, children, vertical = true){

		// 	// just to be doubly sure there's an animation method...
		// 	if ('animate' in parent && typeof parent.animate === 'function') {

		// 		// we're going to recreate the marquee animation when the viewport is resized
		// 		// so get rid of any existing animation first
		// 		if( typeof marquee !== 'undefined' ) marquee.cancel()

		// 		// now for the playing/pausing
		// 		parent.addEventListener('mouseenter', () => {
		// 			if( marquee.playState === 'running' ) marquee.pause()
		// 		}, false)
		// 		parent.addEventListener('mouseleave', () => {
		// 			if( marquee.playState === 'paused' ) marquee.play()
		// 		}, false)

		// 		// set this dynamically, so the thing will gracefully degrade to a typical grid of items
		// 		parent.style.whiteSpace = 'nowrap'

		// 		// create a variable for the distance by which the grid element will be transformed
		// 		var displacement = 0

		// 		// the width of all the elements in the marquee
		// 		// it's important to tot up the child element widths because if overflow is hidden,
		// 		// the clientWidth of the grid_to_animate element will be that of the parent element
		// 		for ( var j = 0; j < children.length; ++j ) displacement += vertical ? children[j].clientHeight : children[j].clientWidth

		// 		// crucial: subtract the width of the container
		// 		// take the opportunity to round the displacement value down to the nearest pixel
		// 		// the browser may thank you for this by not blurring the shit out of your text
		// 		// displacement = (displacement - vertical ? parent.clientHeight : parent.clientWidth) << 0

		// 		let destinationTransform = vertical ? { transform: `matrix(1, 0.00, 0.00, 1, 0, ${-displacement})`, offset: 1 } : { transform: `matrix(1, 0.00, 0.00, 1, ${-displacement}, 0)`, offset: 1 }
		// 		// by using the variable 'marquee' we created in the parent scope,
		// 		// we can easily use the reference to pause/cancel the animation later if necessary
		// 		marquee = parent.animate([
		// 		// these are your keyframes, if you are familiar with the CSS syntax
		// 		// so your 'from' or '0%' keyframe translates to 'offset: 0'
		// 		// 'to'/'100%' translates to 'offset: 1'
		// 		// and anything in betwen like '54%' will be 'offset: .54'
		// 			{ transform: 'matrix(1, 0.00, 0.00, 1, 0, 0)', offset: 0 },
		// 			destinationTransform
		// 		// you don't have to use matrix, I just like it
		// 		],
		// 		{
		// 		// animation-duration = 1 second for each element in marquee
		// 		// arbitrary decision
		// 			duration: children.length * 2e3,

		// 			// could be 'ease', 'cubic-bezier(.4,0,.2,1)', etc.
		// 			easing: 'linear',

		// 			// useful if you don't want the animation to start until your content has loaded from, say, a REST API and you want to speculate a reasonable time for that to take
		// 			delay: 0,

		// 			// kind of crucial for a marquee...
		// 			iterations: Infinity,

		// 			// invert animation after completion, so it scrolls backwards */
		// 			direction: 'normal',

		// 			// you would use this if your animation is set to occur only a finite number of times, and you wanted the animated element to finish at the end keyframe, rather than the first keyframe
		// 			fill: 'forwards'
		// 		})
		// 	}
		// }

		// // quick check for the WAAPI method
		// // you could also do if (typeof grid_to_animate.animate !== 'undefined')
		// // but this is cleaner in my opinion
		// if (marquee_vertical && marquee_vertical_children && 'animate' in marquee_vertical && typeof marquee_vertical.animate === 'function') {

		// 	// okay, let's fire up the marquee!
		// 	createMarquee(marquee_vert, marquee_vertical, marquee_vertical_children, true)

		// }
		// if (marquee_horizontal && marquee_horizontal_children && 'animate' in marquee_horizontal && typeof marquee_horizontal.animate === 'function') {

		// 	// okay, let's fire up the marquee!
		// 	createMarquee(marquee_hort, marquee_horizontal, marquee_horizontal_children, false)

		// }
	} catch (error) {
		console.log('homepage', { message: error.message })
	}
})
